import { PermissionType } from 'enums/permissionType.enum';
import { ApplicationsAnalystListingPage, ApplicationsListingPage, ApplicationsTabbedListingPage } from 'pages';
import { FeatureFlagEnum } from '../../common/feature-flags/enums/feature-flag.enum';
import { isFeatureEnabled } from '../../common/feature-flags/utils/is-feature-enabled.util';
import { useGetUser } from '../../queries';

export const ApplicationsPageWrapper = () => {
  const { data: user } = useGetUser();

  const userAccessGroups = user?.roles.map(r => r.role.type) ?? [];

  const ActiveApplicationsPage = () => {
    if (userAccessGroups.includes(PermissionType.ADMIN) || userAccessGroups.includes(PermissionType.BROKER_SALES)) {
      return <ApplicationsTabbedListingPage />;
    }

    if (userAccessGroups.includes(PermissionType.ANALYST)) {
      return <ApplicationsAnalystListingPage />;
    }

    return isFeatureEnabled(FeatureFlagEnum.BTL_APPLICATION) ? (
      <ApplicationsTabbedListingPage />
    ) : (
      <ApplicationsListingPage />
    );
  };

  return <ActiveApplicationsPage />;
};
